import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1rem;

    .frequentFaq {
        font-size: 2rem;
        padding: 2rem 0 0%;

        @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
            padding: 3.938rem 0 0;
        }
    }

    h2 {
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.5rem;
        margin-bottom: 1rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        h2 {
            line-height: 2rem;
        }
    }
`

export const CollapseContainer = styled.div`
    width: 100%;
    padding: 0 !important;
    margin-bottom: 2rem;

    svg {
        height: 0.75rem;
    }

    h3 {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
    }

    > div {
        & > .multi-text-container {
            & > div {
                height: 100% !important;
            }
        }

        > div {
            font-weight: 600;
            font-size: 1rem;
            line-height: 1.5rem;

            > div {
                font-weight: 400;
                font-size: 0.875rem;

                h3 {
                    height: 100%;
                    color: #363636;
                    font-weight: 400;
                    font-size: 0.875rem;
                    line-height: 1.5rem;

                    & > .cities {
                        text-transform: capitalize;
                    }
                }

                & > .multi-text {
                    font-weight: 500;

                    h3 {
                        font-weight: 400;
                        margin-bottom: 1rem;
                    }
                }
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        flex-direction: column;
        display: flex;
        margin: 0 auto 1.5rem;
        padding: 0;

        h3 {
            font-weight: 700;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        max-width: 54.5rem;
    }
`

export const ButtonBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 0.5rem;
    margin-bottom: 3.875rem;

    button {
        height: 2rem;
        width: 100%;
    }

    a {
        flex: 1;
        display: flex;
        justify-content: center;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        justify-content: center;
        max-width: 21rem;

        button {
            width: 10.063rem;
        }
    }
    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        margin-bottom: 6rem;

        button {
            height: 3rem;
            width: 12.75rem;
        }
    }
`
